import { getPayments } from 'Api/AccountApi';
import { getFrequencyLabel } from 'Utils/Plans';
import { CLEAR_PAYMENT_HISTORY, GET_PAYMENT_ERROR, GET_PAYMENT_REQUEST, GET_PAYMENT_SUCCESS } from '../Types';

// action creators
export const getPaymentSuccess = ({ orders, activeBillInfo, nextBillInfo }) => ({
  type: GET_PAYMENT_SUCCESS,
  orders,
  activeBillInfo,
  nextBillInfo,
});
export const getPaymentRequest = () => ({ type: GET_PAYMENT_REQUEST });
export const getPaymentError = (payload) => ({ type: GET_PAYMENT_ERROR, payload });
export const clearPaymentHistory = () => ({ type: CLEAR_PAYMENT_HISTORY });

// helpers
const getOrdersAndBillInfo = ({ order = [], nextBillInformation = {} }, appId) => {
  let nextBillInfo = null;
  let activeBillInfo = null;
  const orders = order.filter(
    (od) =>
      od.orderProductInfo.some((opi) => opi.appId === appId) && ['INVOICE', 'ORDER'].includes(od.type.toUpperCase())
  );

  // invoice or an order(no free trials)
  const nextBillOrder = orders.find(
    (order) => order.nextBillInformation && order?.paymentsInfo?.[0]?.paymentCategory !== 'REFUND' //REFUND ORDER INVOICE
  );
  if (nextBillOrder) {
    const { nextBillInformation, orderProductInfo = [] } = nextBillOrder;
    const { nextBillingDateTime, nextBillingAmount } = nextBillInformation;
    const activeOrder = orderProductInfo.find((o) => o.appId === appId);

    const { displayName, chargedPrice, retailPrice, duration, period, endDate } = activeOrder;
    const planFrequency = getFrequencyLabel({ duration, period });

    //The next billing subscription may be different than the current one
    activeBillInfo = {
      planName: displayName,
      planPrice: chargedPrice || retailPrice,
      planFrequency,
    };

    nextBillInfo = {
      nextBillingDateTime: nextBillingDateTime > 0 ? nextBillingDateTime : endDate,
      nextBillingAmount,
    };
  }

  // for free trials.
  const subscriptionsInfo = nextBillInformation?.subscriptionsInfo?.find((sub) => sub.appId === appId);
  if (subscriptionsInfo) {
    const { nextBillingDateTime, nextBillingAmount, originalPrice, displayName, duration, period } = subscriptionsInfo;
    const planFrequency = getFrequencyLabel({ duration, period });
    nextBillInfo = {
      nextBillingDateTime,
      nextBillingAmount,
      planName: displayName,
      planPrice: originalPrice,
      planFrequency,
    };
  }

  return { orders, nextBillInfo, activeBillInfo };
};

// action thunks
export const fetchPayments = (appId) => {
  return async (dispatch) => {
    dispatch(getPaymentRequest());
    try {
      const data = await getPayments();
      const ordersAndBillInfo = getOrdersAndBillInfo(data, appId);
      dispatch(getPaymentSuccess(ordersAndBillInfo));
    } catch (error) {
      dispatch(getPaymentError(error.message));
    }
  };
};
